<template>
  <SnowEffect/>
  <KalenderAnsicht/>
</template>
<script>
import SnowEffect from './components/SnowEffect.vue';
import KalenderAnsicht from './components/KalenderAnsicht.vue';
export default {
  name: 'App',
  components: {
    SnowEffect,
    KalenderAnsicht,
  },
};
</script>
<style lang="scss">
@import './scss/variablen.scss';
@import './scss/mixins.scss';
* { margin:0; padding:0 } 
html, body { height:100%; height:100% }
</style>
